import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import axios from "axios";
import Notifications, { notify } from "react-notify-toast";
import styles from "./AjusteInventarioModal.module.css";

const AjusteInventarioModal = ({ show, handleClose, handleAdd }) => {

    const [cookie] = useCookies(['kUserSession']);
    const loadingBtn = require("../../../assets/loaders/btn-loading.gif");

    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [categoria, setCategoria] = useState(0);
    const [carimbo, setCarimbo] = useState(undefined);
    const [cantidad, setCantidad] = useState(0);

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    };

    const retrieveCategories = () => {
        axios.get(process.env.REACT_APP_API_URL + "category", prepareHeaders())
        .then(rs => {
            if(rs.status === 200){
                let { data } = rs.data;
                setCategories(data);
            }
            else {
                setCategories([]);
            }
        })
        .catch(error => {
            console.error(error);
            setCategories([]);
        });
    };

    const handleSave = () => {
        const cat = categories.find(c => c.id_categoria == categoria);
        if(cat && cantidad > 0){
            const movement = {
                idCategoria: parseInt(categoria),
                nombre: cat.nombre,
                carimbo: carimbo ? parseInt(carimbo) : undefined,
                entradas: 0,
                salidas: 0,
                existencia: 0,
                real: parseInt(cantidad)
            };
            handleAdd(movement);
            handleClose();
        }
        else {
            notify.show("Debe completar todos los campos", "warning");
        }
    };

    useEffect(() => {
        retrieveCategories();
    }, []);

    return (
        <>
            <Notifications />
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title><b>Agregar categoría</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="categoria">
                                    <Form.Label>Categoría</Form.Label>
                                    <Form.Control as="select" className="karanda-input" value={categoria} onChange={(e) => setCategoria(e.target.value)}>
                                        <option value={0}>Seleccione la categoría</option>
                                        {
                                            categories.map(i => (
                                                <option key={i.id_categoria} value={i.id_categoria}>{i.nombre}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="carimbo">
                                    <Form.Label>Carimbo</Form.Label>
                                    <Form.Control className="karanda-input" value={carimbo} onChange={(e) => setCarimbo(e.target.value)} type="number" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="cantidad">
                                    <Form.Label>Cantidad</Form.Label>
                                    <Form.Control className="karanda-input" value={cantidad} onChange={(e) => setCantidad(e.target.value)} type="number" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                    <Button variant="primary" onClick={handleSave}>
                        {
                            loading ? (
                                <img src={loadingBtn} height="15" />
                            ) : (<span>Agregar</span>)
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AjusteInventarioModal;

